import { ThemeSet } from "../../types";
import { generateThemeFromPalette } from "../../utils";
import { freePalette } from "../palette/freePalette";

export const freeLightTheme = generateThemeFromPalette(freePalette, "light");
const freeDarkTheme = generateThemeFromPalette(freePalette, "dark");

export const free: ThemeSet = {
  light: {
    ...freeLightTheme
  },
  dark: {
    ...freeDarkTheme
  }
};
